import React from "react";
import Logo from "../images/svc-central-logo.jpg";
import "./Style.css";
import { BRAND_PORTAL_TITLE } from "../branding";

const Navbar = () => (
  <nav className="nav sco-auth-nav">
    <div className="containercs">
      <img className="img-cs" src={Logo} alt={BRAND_PORTAL_TITLE} />
      <div className="navbar-heading" to="/">
        {BRAND_PORTAL_TITLE}
      </div>
      {/* ... rest of your navbar ... */}
    </div>
  </nav>
);

export default Navbar;
